let path = "";

if (window.location.href.indexOf("hrdesk.africa") >= 0) {
  // production server
  path = "https://api.hrdesk.africa";
} else if (window.location.href.indexOf("54.234.82.40") >= 0) {
  // staging server
  path = "http://54.234.82.40:8080";
} else if (window.location.href.indexOf("localhost:8080") >= 0) {
  // Femi
  path = "http://54.234.82.40:8080";
} else {
  // Default - MJ Local
  path = "http://localhost:8085";
}

// STATIC DOCUMENTS

export const STATIC_PAYROLL_TEMPLATE = `${path}/documents/payroll.xlsx`;
export const STATIC_STAFF_TEMPLATE = `${path}/documents/staff_template.xlsx`;

export const GET_ALL_PERMISSIONS_LIST = `${path}/v1/permissions/get-all`;
export const GET_USER_PERMISSIONS_LIST = `${path}/v1/permissions/:user_id`;

// onboard
export const GET_STAFF_ID_API = `${path}/v1/generate-staff-id`;
export const UPDATE_PASSWORD_API = `${path}/v1/auth/change-password`;
export const GET_BANK_CODES = `${path}/v1/bank-codes`;
export const CREATE_USER = `${path}/v1/auth/company-register`;
export const VERIFY_EMAIL = `${path}/v1/auth/verify-email`;
export const RESEND_OTP = `${path}/v1/auth/resend-verify-email`;

// virtual account
export const CREATE_VIRTUAL_ACCOUNT_API = `${path}/v1/virtual-account`;
export const FETCH_VIRTUAL_ACCOUNT_API = `${path}/v1/virtual-account`;

// auth
export const LOGIN_API = `${path}/v1/auth/login`;
export const CHANGE_PASSWORD_API = `${path}/v1/auth/password`;
export const COMPANY_ONBOARD_API = `${path}/v1/auth/company-register`;

// address
export const COUNTRY_API = `${path}/v1/parameters/countries`;
export const STATE_API = `${path}/v1/parameters/states`;
export const CITY_API = `${path}/v1/parameters/cities`;

// industry
export const INDUSTRY_API = `${path}/v1/parameters/industries`;
export const ONBOARDING_INDUSTRY_API = `${path}/v1/auth/industries`;

// company
export const COMPANY_UPDATE_API = `${path}/v1/companies`;
export const COMPANY_GET_API = `${path}/v1/companies`;

// user
export const API_KEYS = `${path}/v2/api-keys`;
export const API_KEYS_ROTATE = `${path}/v2/api-keys/rotate`;
export const ADMIN_API = `${path}/v1/admins`;
export const ADD_ADMIN_API = `${path}/v1/admin/new`;
export const REMOVE_ADMIN_API = `${path}/v1/admin/revoke-priviledges`;
export const PERMISSION_API = `${path}/v1/permissions/get-all`;
export const USER_PERMISSION_API = `${path}/v1/permissions`;
export const USER_SEARCH_API = `${path}/v1/employees/search`;

// employees
export const GET_EMPLOYEES_API = `${path}/v1/employees`;
export const GET_NON_EMPLOYEES_API = `${path}/v1/employees/get-non-admins`;
export const UPDATE_ADMIN_ACCOUNT = `${path}/v1/employees/setup-admin-account`;
export const UPDATE_JOB_AND_PAY = `${path}/v1/employees/job-and-pay`;
export const UPDATE_PROFILE_DATA = `${path}/v1/employees/update-profile-data`;
export const POST_EMPLOYEE_DOCUMENT_API = `${path}/v1/employees/documents`;
export const ONBOARD_MULTIPLE_EMPLOYEES = `${path}/v1/employees/multiple-employees`;
export const GET_BIRTHDAYS = `${path}/v1/upcoming_birthdays`;
export const POST_EMPLOYEES_CSV = `${path}/v1/bulk/employees`;
export const GET_EMPLOYEES_FILTER_API = `${path}/v1/employees/filter`;
export const ACTIVATE_EMPLOYEES_API = `${path}/v1/employees/activate`;
export const GET_ALL_EMPLOYEES_API = `${path}/v1/companies/employees`;
export const SEND_INVITE_LINK = `${path}/v1/employees/resend-invite-link`;

// payroll
export const GET_PAYROLL_COST = `${path}/v1/payroll/payroll-cost`;
export const GET_PAYROLL = `${path}/v1/payroll/show`;
export const GET_PAYROLL_COMPONENTS_API = `${path}/v1/payroll/components`;
export const PAYROLL_SETTING_API = `${path}/v1/payroll/settings`;
export const PAYROLL_BREAKDOWN_GET_API = `${path}/v1/payroll/employees`;
export const PAYROLL_BREAKDOWN_POST_API = `${path}/v1/payroll/preview`;
export const PAYROLL_SUBMIT = `${path}/v1/payroll/submit`;
export const PAYOUT_HISTORY = `${path}/v1/companies/payouts`;
export const PAYOUT_HISTORY_FILTER = `${path}/v1/companies/payouts/filter`;
export const PAYOUT_HISTORY_STATUS = `${path}/v1/transactions/payout/status`;
export const PAYOUT_HISTORY_RETRY = `${path}/v1/transactions/payout/retry`;
export const PAYOUT_PAYNOW = `${path}/v1/transactions/payouts`;
export const RETRY_TRANSACTION = `${path}/v1/transactions/retry`;
export const PAYOUT_CANCEL = `${path}/v1/payroll`;
export const PAYROLL_TRANSACTION_DETAILS = `${path}/v1/payroll`;

// payroll history
export const PAYROLL_HISTORY = `${path}/v1/payroll/history`;
export const PAYROLL_HISTORY_BREAKDOWN = `${path}/v1/payroll/breakdown`;

// designations
export const GET_DESIGNATION_API = `${path}/v1/parameters/designations`;

// resources
export const GET_RESOURCES_API = `${path}/v1/users/resources`;

// benefits
export const GET_HMOS_API = `${path}/v1/benefits/hmos`;
export const GET_OTHER_BENEFITS_API = `${path}/v1/benefits/others`;
export const HMO_SUBSCRIBE_API = `${path}/v1/benefits/subscribe/hmo`;
export const OTHER_BENEFTIS_SUBSCRIBE_API = `${path}/v1/benefits/subscribe/others`;
export const OTHER_BENEFTIS_REMOVAL_API = `${path}/v1/benefits/subscribe/remove`;
export const GET_PFAS = `${path}/v1/pfas`;

// banks
export const BANKS_API = `${path}/v1/parameters/banks`;

// queries
export const UPLOAD_QUERY_DOCUMENTS = `${path}/v1/queries/upload-documents`;
export const GET_QUERY_API = `${path}/v1/queries`;
export const GET_HMO_HOSPITALS_API = `${path}/v1/benefits/hmo-hospitals`;
export const CREATE_HMO_PLAN_API = `${path}/v1/benefits/hmo-plans`;

// promotions
export const GET_PROMOTION_API = `${path}/v1/promotions`;

// leave
export const LEAVE_SETTING = `${path}/v1/leave/settings`;
export const LEAVE_TYPE = `${path}/v1/leave/types`;
export const LEAVE_ASSIGN = `${path}/v1/leave/assign`;
export const LEAVE = `${path}/v1/leave`;
export const LEAVE_APPLICATIONS = `${path}/v1/leave/applications`;
export const LEAVE_APPROVAL = `${path}/v1/leave/approval`;

// levels
export const GET_LEVEL_API = `${path}/v1/levels`;
export const PROMOTION_API = `${path}/v1/promotions`;

// level
export const EMPLOYMENT_LEVEL_API = `${path}/v1/levels`;

// employee portal
export const GET_EMPLOYEE_API = `${path}/v1/employee`;
export const GET_EMPLOYEE_QUERY_API = `${path}/v1/employee/queries`;
export const POST_EMPLOYEE_FILE_API = `${path}/v1/employee/documents`;
export const EMPLOYEE_API = `${path}/v1/employee`;
export const UPDATE_EMPLOYEE_PERSONAL_INFORMATION = `${path}/v1/employee/update-personal-information`;
export const UPDATE_EMPLOYEE_PAYMENT_INFORMATION = `${path}/v1/employee/update-payment-information`;

// jobseekers
export const INTERVIEW_INVITE = `${path}/v1/jobseekers/invite`;

// jobseeker portal
export const GET_PROFILE = `${path}/v1/jobseekers`;
export const UPDATE_PROFILE = `${path}/v1/jobseekers/profile`;
export const GET_STATE = `${path}/v1/parameters/states/160`;
export const GET_CITIES = `${path}/v1/parameters/cities`;
export const GET_JOB_ROLES = `${path}/v1/parameters/jobroles`;
export const GET_JOBS = `${path}/v1/jobs`;
export const SEARCH_JOBS = `${path}/v1/jobs/search`;
export const JOBSEEKER_DOCUMENT_UPLOAD = `${path}/v1/jobseekers/documents`;
export const JOBSEEKER_PAY = `${path}/v1/jobseekers/pay`;
export const JOB_APPLY = `${path}/v1/jobseekers/job-apply`;

// accounts
export const ACCOUNTS_API = `${path}/v1/transactions/accounts`;

// wallet
export const COMPANY_WALLET = `${path}/v1/transactions/wallets`;

// overview
export const OVERVIEW_API = `${path}/v1/users/dashboard`;

// document
export const EMPLOYEE_DOCUMENT_UPLOAD_API = `${path}/v1/documents/employees`;
export const ADMIN_DOCUMENT_DELETE = `${path}/v1/documents`;

// inquiry
export const INQUIRY_API = `${path}/v1/inquiry`;

// payslip
export const EMPLOYEE_PAYSLIP = `${path}/v1/employee/payslips`;
export const EMPLOYEE_PAYSLIP_SHOW = `${path}/v1/employee/payslips`;

// Department
export const GET_DEPARTMENTS = `${path}/v1/departments`;
export const CREATE_DEPARTMENT = `${path}/v1/departments`;
export const CREATE_DESIGNATION = `${path}/v1/parameters/designations`;
export const EDIT_DESIGNATION = `${path}/v1/designations`;
export const DELETE_DESIGNATION = `${path}/v1/designations`;

// s3 bucket
export const S3_BUCKET_URL =
  "https://api-staging-hrdesk-hr360-bucket.s3.eu-west-1.amazonaws.com";

// auth store
export const AUTH_REQUEST = "auth/auth_request";
export const AUTH_SUCCESS = "auth/auth_success";
export const USER_DETAILS = "auth/user_details";
export const AUTH_ERROR = "auth/auth_error";
export const AUTH_LOGOUT = "auth/auth_logout";
export const COMPANY_AUTH_REGISTER = `${path}/v1/auth/company-register`;
export const JOBSEEKER_AUTH_REGISTER = `${path}/v1/jobseekers`;
